import { http } from '@/http/index'

export const getGirlsList = async () => http.get('/temafon-girls').then((response) => response.data)
